import { useState } from "react"
import { createPortal } from "react-dom"
import { toast } from "react-toastify"
import classNames from "classnames"

import {
  useLazyGetAdminDevicesQuery,
  useLazyGetInstalledDevicesWidgetQuery,
  useLazyGetPhysicalStatusesWidgetQuery,
  useLazyPutTransferDevicesQuery,
} from "store/api/adminApi"
import { useLazyGetContractorsQuery } from "store/api/contractorsApi"
import { useAppDispatch, useAppSelector } from "store/hooks"
import { setSelectedDeviceIDs } from "store/tempDataSlise"
import { UITypes } from "types"
import { ReactComponent as IconTransfer } from "assets/svg/modal-icon-transfer.svg"

import getErrorMessage from "utils/getErrorMessage"
import useUrlQueryParams from "hooks/useUrlQueryParams"
import { ModalLayout } from "layouts/ModalLayout"
import { SelectDynamic } from "components/form/SelectDynamic"

import styles from "./index.module.scss"

interface Props {
  onCancel: () => void
}

export const TransferDeviceModal = ({ onCancel }: Props) => {
  const [selectedContractor, setSelectedContractor] = useState<undefined | UITypes.Option[]>(undefined)
  const [triggerTransferDevices, { isFetching }] = useLazyPutTransferDevicesQuery()
  const [triggerGetPhysicalStatusesWidget] = useLazyGetPhysicalStatusesWidgetQuery()
  const [triggerGetInstalledDEvicesWidget] = useLazyGetInstalledDevicesWidgetQuery()
  const [triggerGetAdminDevices] = useLazyGetAdminDevicesQuery()
  const dispatch = useAppDispatch()
  const [errorMessage, setErrorMessage] = useState("")
  const selectedDeviceIDs = useAppSelector(state => state.tempData.selectedDeviceIDs)
  const { urlQueryParams } = useUrlQueryParams()

  const onSubmit = async (event: React.FormEvent) => {
    event.preventDefault()

    if (!selectedContractor?.length) {
      setErrorMessage("Please select a contractor")
      return
    }

    try {
      const res = await triggerTransferDevices({
        device_ids: selectedDeviceIDs,
        contractor_id: selectedContractor[0]?.value as string,
      })
      const error = getErrorMessage(res?.error)

      if (res?.error) {
        toast.error(error)
      } else {
        toast.success("The status of the selected device(s) was changed successfully!")
        dispatch(setSelectedDeviceIDs([]))
        triggerGetAdminDevices(urlQueryParams)
        triggerGetPhysicalStatusesWidget()
        triggerGetInstalledDEvicesWidget()
        onCancel()
      }
    } catch (error) {
      console.error(error)
    }
  }

  return (
    <>
      {createPortal(
        <ModalLayout width="450px" isFetching={isFetching} onConfirm={onSubmit} onCancel={onCancel}>
          <div className={classNames(styles.modalContent, styles.center)}>
            <IconTransfer />
            <h3 className={styles.modalTitle}>Transfer</h3>
            <div className={styles.modalMessage}>
              Are you sure you want to transfer the device(s) to the selected Contractor?
            </div>
            <div className={styles.selectWrapper}>
              <SelectDynamic
                values={selectedContractor || []}
                label="Contractors"
                valueName="id"
                labelName="name"
                placeholder="Select contractor"
                name="name"
                errorMessage={errorMessage}
                useLazyQuery={useLazyGetContractorsQuery}
                onChange={setSelectedContractor}
              />
            </div>
          </div>
        </ModalLayout>,
        document.body,
      )}
    </>
  )
}
